import { createResetStateMutation } from '@/helpers';
import { getInitialStateCreditos } from './state';

export const setScoreField = (state, payload) => {
   const { key, value } = payload;
   state.scoreForm[key] = value;
};

export const setSimuladorField = (state, payload) => {
   const { key, value } = payload;
   state.simuladorForm[key] = value;
};

export const setScoreLoading = (state, payload) => {
   state.loadingScore = payload;
};

export const setScoreEnviado = (state, payload) => {
   state.scoreEnviado = payload;
};

export const setSimulacionResultado = (state, payload) => {
   state.simulacionResultado = payload;
};

export const setScoreForm = (state, payload) => {
   state.scoreForm = {
      ...state.scoreForm,
      ...payload,
   };
};

export const setSimuladorForm = (state, payload) => {
   state.simuladorForm = {
      ...state.simuladorForm,
      ...payload,
   };
};

export const resetState = createResetStateMutation(getInitialStateCreditos);
